import { EventUrgencyClassEditItem, IEventUrgencyClassEditItem } from "./eventUrgencyClassEditItem";

export interface IEventUrgencyClassEdit {
    item: IEventUrgencyClassEditItem;
}

export class EventUrgencyClassEdit implements IEventUrgencyClassEdit {
    item: EventUrgencyClassEditItem;

    constructor();
    constructor(obj: IEventUrgencyClassEdit);
    constructor(obj?: any) {
        this.item = new EventUrgencyClassEditItem(obj ? obj.item : null);
    }
}